/* src/app/app.component.scss */
ion-menu ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
  --color: var(--ion-color-primary);
}
ion-menu ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}
/*# sourceMappingURL=app.component.css.map */
